/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import {
  filterPeopleByRole,
  IMediaModel,
  MediaType,
  PersonInAssetType,
  useIsPlayableWithDate,
} from "@nf/common";
import { useTranslation } from "next-i18next";

import MediaAdditionalInfo from "../MediaAdditionalInfo";

import styles from "./MediaDetailsAdditionalInfo.module.scss";

export interface MediaDetailsAdditionalInfoProps {
  media: IMediaModel;
}

export const MediaDetailsAdditionalInfo = ({
  media,
}: MediaDetailsAdditionalInfoProps): JSX.Element => {
  const { isExpiring, availableTo } = useIsPlayableWithDate(media);
  const { t } = useTranslation("translations");

  const director = filterPeopleByRole(
    media.People,
    PersonInAssetType.Director
  )?.[0];

  const numberOfSeasons =
    media.MediaTypeCode === MediaType.Series ? media.Media?.length : 0;
  const numberOfEpisodes =
    media.MediaTypeCode === MediaType.Series
      ? media.Media?.reduce(
          (total, season) => total + (season.Media?.length ?? 0),
          0
        )
      : 0;

  return (
    <div className={styles.info}>
      <h1 className={styles.title}>{media.Title}</h1>

      <div className={styles.metadata}>
        {director && (
          <span className={styles.director}>{director.PersonFullName}</span>
        )}

        <MediaAdditionalInfo
          seasons={numberOfSeasons}
          episodes={numberOfEpisodes}
          year={media.Year}
          duration={media.Duration}
          className={styles.additionalDescription}
        />
      </div>

      {isExpiring && (
        <p className={styles.expire}>
          {t("web_asset_page_expire")} {availableTo}
        </p>
      )}
    </div>
  );
};

export default MediaDetailsAdditionalInfo;
